// Comisión Directiva: se lee en vivo desde la pestaña "Comisión Directiva"
// de la planilla "Socios UIQ". Mariano la edita y la web se actualiza sola.
import { PADRON_SHEET_ID, parseCSV, normalizar } from './padron';

const CD_GID = '2024058380';
const CSV_URL = `https://docs.google.com/spreadsheets/d/${PADRON_SHEET_ID}/export?format=csv&gid=${CD_GID}`;

const MESA = ['presidente', 'vicepresidente', 'secretario', 'prosecretario', 'tesorero', 'protesorero'];

const limpiar = (s) => (s || '').replace(/\s+/g, ' ').trim();

export function agruparComision(rows) {
  if (!rows.length) return null;
  const h = rows[0].map(normalizar);
  const col = (n) => h.indexOf(n);
  const iC = col('cargo'), iN = col('nombre'), iE = col('empresa');

  const personas = rows
    .slice(1)
    .map((r) => ({
      cargo: limpiar(r[iC]),
      nombre: limpiar(r[iN]),
      empresa: limpiar(r[iE]),
    }))
    .filter((p) => p.cargo && p.nombre);

  const g = { mesa: {}, vocalesTitulares: [], vocalesSuplentes: [], revisoresTitulares: [], revisoresSuplentes: [] };
  personas.forEach((p) => {
    const c = normalizar(p.cargo);
    const orden = parseInt((c.match(/\d+/) || [0])[0], 10);
    const conOrden = { ...p, orden };
    if (MESA.includes(c)) g.mesa[c] = p;
    else if (c.includes('vocal') && c.includes('titular')) g.vocalesTitulares.push(conOrden);
    else if (c.includes('vocal') && c.includes('suplente')) g.vocalesSuplentes.push(conOrden);
    else if (c.includes('revisor') && c.includes('titular')) g.revisoresTitulares.push(conOrden);
    else if (c.includes('revisor') && c.includes('suplente')) g.revisoresSuplentes.push(conOrden);
    // Cualquier otro cargo no se muestra
  });
  ['vocalesTitulares', 'vocalesSuplentes', 'revisoresTitulares', 'revisoresSuplentes'].forEach((k) => g[k].sort((a, b) => a.orden - b.orden));
  return g;
}

export async function fetchComision() {
  const res = await fetch(`${CSV_URL}&t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return agruparComision(parseCSV(await res.text()));
}
